module.exports = __webpack_public_path__ + "img/bottom_ewm.8e636bba.png";